import { useCallback, useState } from 'react';
import { tBannerItem, tGlobalBannerContext } from './GlobalBanner.types';
import { tErrorModule } from 'src/utils/ErrorDirectory.types';

export default function useGlobalBanner(): tGlobalBannerContext {
  const [banners, setBanners] = useState<tBannerItem[]>([]);

  const showBanner = useCallback((banner: tBannerItem) => {
    setBanners((prev) => {
      // Deduplicate by code
      if (prev.some((b) => String(b.code) === String(banner.code))) {
        return prev;
      }
      return [...prev, banner];
    });
  }, []);

  const dismissBanner = useCallback((code: number | string) => {
    setBanners((prev) => prev.filter((b) => String(b.code) !== String(code)));
  }, []);

  const getBannersForModule = useCallback(
    (module: tErrorModule): tBannerItem[] => {
      // When requesting 'all', return every active banner
      if (module === 'all') return banners;

      return banners.filter((banner) => {
        if (!banner.modules || banner.modules.length === 0) return true;
        return banner.modules.includes('all') || banner.modules.includes(module);
      });
    },
    [banners],
  );

  return { showBanner, dismissBanner, getBannersForModule };
}
